import { createActions } from 'redux-actions';
import types from './types';

const { setToken, clearToken } = createActions(types.SET_TOKEN, types.CLEAR_TOKEN);

export default { setToken, clearToken };



// WEBPACK FOOTER //
// ./src/reducers/auth/actions.js